import { render, staticRenderFns } from "./DriverTable.component.vue?vue&type=template&id=43ca4c8a"
import script from "./DriverTable.component.vue?vue&type=script&lang=ts"
export * from "./DriverTable.component.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports